import styled from '@emotion/styled';
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

/*
 *If we build M&C treatment variation we should
 *provide to the ListItem ppReact <BodyText/> component
 *which is going to have all required CSS styles. Hence,
 *no need to write our own CSS
 */
export const StyledListItem = styled.li``;
const commonStyles = ({ margin }: { margin?: string }): SerializedStyles => css`
  width: 100%;
  height: auto;
  margin: ${margin ? margin : 'initial'};
  padding-inline-start: 16px;
`;

export const UnorderedList = styled.ul<{ margin?: string }>`
  ${({ margin }) => commonStyles({ margin })};
  list-style-type: disc;
`;

export const OrderedList = styled.ol<{ margin?: string }>`
  ${({ margin }) => commonStyles({ margin })};
  list-style-type: decimal;
`;
